import { render } from "./FormPreview.vue?vue&type=template&id=7c25a058"
import script from "./FormPreview.vue?vue&type=script&lang=js"
export * from "./FormPreview.vue?vue&type=script&lang=js"

import _style_0 from "./FormPreview.vue?vue&type=style&index=0&id=7c25a058&inline&lang=scss"

import exportComponent from "D:\\Projects\\FormBuilder\\vue_project\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]]])

export default __exports__